import React from 'react';
import PropTypes from 'prop-types';
import NumberUtils from 'lib/NumberUtils';

// HTTP
import { useQuery } from '@apollo/client';
import { FetchPolicy } from 'utils/enum/Core';
import LotQuery from 'services/graphQL/query/LotQuery';

import ModalUtils from 'utils/ModalUtils';
import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme = {}) => ({
    redLabel: {
        color: theme.palette.text.oldBrick,
    },
    label: {
        color: theme.palette.text.boulder,
        fontWeight: 500,
        fontFamily: 'Roboto',
        fontSize: '13px',
    },
}));

const DownPaymentReceived = (props) => {
    const classes = useStyle();
    const {
        lotName, cashDownPayment, downPaymentReceived,
    } = props;

    const { data: lotData = {}, loading: lotLoading, error: lotError } = useQuery(LotQuery.GET_SETTINGS, {
        variables: { category: 'Deals', key: 'allowTransferWithoutDownpayment', lotName },
        fetchPolicy: FetchPolicy.NETWORK_ONLY,
    });

    if (lotError) {
        ModalUtils.errorMessage(lotError?.graphQLErrors);
    }

    const allowTransfer = JSON.parse(lotData.getSettings?.[0]?.value || true);

    const markRed = !allowTransfer && downPaymentReceived < cashDownPayment;

    return !lotLoading ? (
        <>
            <div className={classes.label}>Down Payment Received</div>
            <div className={markRed ? classes.redLabel : ''}>{` ${NumberUtils.applyCurrencyFormat(downPaymentReceived)}`}</div>
        </>
    ) : null;
};

DownPaymentReceived.propTypes = {
    lotName: PropTypes.string.isRequired,
    cashDownPayment: PropTypes.number,
    downPaymentReceived: PropTypes.number,
};

DownPaymentReceived.defaultProps = {
    cashDownPayment: 0,
    downPaymentReceived: 0,
};

export default DownPaymentReceived;
